
import styled from 'styled-components'

export const FormFilter = styled.form`
	display: flex;
	flex-direction: row;
	align-items: flex-end;
	flex-wrap: ${props => (props.$wrap ? 'wrap' : 'nowrap')};
	gap: 16px;
	width: 100%;
	@media (max-width: 768px) {
		display: flex;
		gap:24px;

		flex-direction: column;
		flex-wrap: nowrap;
	}
`

export const SelectInvoiceNumber = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	gap: 8px;
	
`
export const PeriodoDiv = styled.div`
display: flex;
flex-direction: column;
gap: 8px;
width: calc(33.33% - 11px);
margin-bottom: 8px;

@media (max-width: 768px) {
width: 100%;
}
`